import { render, staticRenderFns } from "./AddressValidationBadge.vue?vue&type=template&id=8018f580"
import script from "./AddressValidationBadge.vue?vue&type=script&lang=js"
export * from "./AddressValidationBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports